import contextChannelIdLink from "@magalu/ecomm-components/rave/apollo/contextChannelIdLink";

export const middlewares = [contextChannelIdLink({ isMiniApp: true })];
